const ip: string = process.env.REACT_APP_BACKEND_API || '';
const ipAdmin: string = process.env.REACT_APP_BACKEND_ADMIN_API || '';
if (!ip) {
  throw new Error("REACT_APP_BACKEND_API is not defined");
}
if (!ipAdmin) {
  throw new Error("REACT_APP_BACKEND_ADMIN_API is not defined");
}
const urls = {};

export { urls, ip, ipAdmin };
